<template>
  <div>
    <el-card class="card" :body-style="{ padding: '0px' }">
      <div @click="getCreativesInfo">
        <el-button class="fly-button" size="mini" round>
          {{ item.creatives }} {{ plural(['креатив', 'креатива', 'креативов'], item.creatives) }}
        </el-button>
        <div class="image" :style="{'background-image': 'url(' + item.screen + ')'}"></div>
      </div>
      <div style="padding: 14px;">
        <h4>{{ item.title }}</h4>
        <div class="list mt-2 mb-4">
          <span>CPM:</span> {{ item.market_cpm }}
        </div>
        <div class="bottom clearfix">
          <el-button type="success" @click="$emit('onSelect', item)" size="small" round>
            Разместить
          </el-button>
        </div>
      </div>
    </el-card>
    <el-dialog title="Просмотр креативов" :visible.sync="creativesModal" width="30%" height="max-content">
      <el-carousel class="mb-2" arrow="always" @change="onCarouselChange">
        <el-carousel-item v-for="creative in creatives" :key="creative.id" height="max-content">
          <el-image
              class="borderedScreen" :src="creative.screen" v-if="creative.screen"
              :preview-src-list="[creative.screen]">
          </el-image>
        </el-carousel-item>
      </el-carousel>

      <div v-if="creatives[selectedCreative]">
        <h4>
          Информация о креативе "{{ creatives[selectedCreative].title }}"
          <a :href="creatives[selectedCreative].screen" target="_blank"><i class="el-icon-link"></i></a>
        </h4>
        <small>{{ creatives[selectedCreative].text }}</small>
        <div class="list mt-2 mb-4">
          <span>Репост:</span>
          <div class="inline" v-if="creatives[selectedCreative].repost">
            <a :href="'https://vk.com/' + creatives[selectedCreative].repost">{{ creatives[selectedCreative].repost }}</a>
          </div> <div class="inline" v-else>-</div>
          <br>
          <span>Источник:</span>
          <div class="inline" v-if="creatives[selectedCreative].source">
            <a :href="creatives[selectedCreative].source">{{ creatives[selectedCreative].source }}</a>
          </div> <div class="inline" v-else>-</div>
          <br>
        </div>
      </div>

      <div>
        <el-button @click="creativesModal = false">Закрыть</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MarketItem",
  props: {
    item: Object
  },
  data() {
    return {
      creativesModal: false,
      creatives: [],
      selectedCreative: 0,
    }
  },
  methods: {
    onCarouselChange(index) {
      this.selectedCreative = index;
    },
    getAsLink(link) {
      return ;
    },
    getCreativesInfo() {
      this.$store.commit('setLoader', 1);
      this.$store.dispatch('publisher/getTaskCreatives', {
        id: this.item.id
      }).then((response) => {
        this.creatives = response.data.data;
        this.creativesModal = true;
      }).finally(() => {
        this.$store.commit('setLoader', 0);
      });
    },
    plural(forms, n) {
      let idx;
      if (n % 10 === 1 && n % 100 !== 11) {
        idx = 0;
      } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        idx = 1;
      } else {
        idx = 2;
      }
      return forms[idx] || '';
    }
  }
}
</script>

<style scoped>
  .image {
    background-size: cover;
    height: 180px;
    cursor: pointer;
  }
  .fly-button {
    position: absolute;
    margin-top: 9px;
    right: 20px;
  }
  .list span {
    font-weight: 400;
  }
  .list {
    font-weight: 500;
  }
  .borderedScreen {
    width: 100%;
  }
  .card {
    min-height: 337px;
    height: 100%;
  }
</style>
